// @flow
import * as Sentry from '@sentry/react';
import * as React from 'react';
import Container from './Container';
import { EVENT_TYPES } from '../HOCs/withEventManager';
import APIError from '../lib/APIError';
import type { TRootState } from '../reducers';
import type { TEventManagerProps } from '../HOCs/withEventManager';


type TProps = {
  children: React.Node,
} & TRootState & TEventManagerProps;

type TState = {
  hasError: boolean,
};

class APIErrorBoundary extends React.Component<TProps, TState> {
  constructor(props: TProps) {
    super(props);

    this.state = { hasError: false };
  }

  componentDidCatch(error: Error) {
    this.setState({ hasError: true });

    if (error instanceof APIError) {
      this.props.dispatchEvent(EVENT_TYPES.error, error.toObject(), () => this.props.dispatchEvent(EVENT_TYPES.exit, {}));
      return;
    }

    // Not our errors
    this.props.dispatchEvent(EVENT_TYPES.error, {
      type: 'API_ERROR',
      sub_type: 'INTERNAL_ERROR',
      message: 'An unexpected error occurred. Our team has been notified of this issue. Please re-try your request, if this error persists contact support.',
      code: 500,
    }, () => this.props.dispatchEvent(EVENT_TYPES.exit, {}));


    Sentry.withScope((scope) => {
      scope.setTag('REACT_APP_VERSION', process.env.REACT_APP_VERSION);

      scope.setTag('navigation.current.path', this.props.navigation.current.path);

      scope.setTag('config.initialized', this.props.config.initialized);
      scope.setTag('config.entity_id', this.props.config.entity_id);
      scope.setTag('config.mch_id', this.props.config.mch_id);
      scope.setTag('config.mask', this.props.config.mask);
      scope.setTag('config.team_name', this.props.config.team_name);

      scope.setLevel('error');
      Sentry.captureException(error);
    });
  }

  render() {
    return this.state.hasError
      ? null
      : <Container flex centered full>{this.props.children}</Container>
  }
}

// $FlowFixMe
export default APIErrorBoundary;
